<template>
  <div class="GroupItemConfig">
    <!-- 分组组件头部标题 -->
    <div class="group-list-header">
      <div class="title">分组管理</div>
      <el-button type="text" @click.stop="dialogManage(newDomainDialog).show()">
        <i class="el-icon-circle-plus-outline"></i>
        添加组</el-button>
    </div>
    <!-- 分组组件列表 -->
    <draggable class="group-list-wrap" tag="ul"
               :list="domainList"
               :clone="(config) => undefined"
               @end="endDraggableDomain"
               v-bind="{group:{name:'domain_components', pull:'clone', put:false}, 
                        ghostClass:'ghost'}">
      <!-- 组组件项 -->
      <li class="group-component-item"  
          :class="{ 
            'is-editing': domainEditManager().isEqual(item),
            'domain': true 
          }"
          v-for="(item,index) in domainList" 
          :key="index" 
          @click="beforeEditDomain(item)">
        <!-- 组组件标题 -->
        <div class="group-label">
          <i :class="['iconfont', domainManager(item).getIcon()]"></i>
          <span v-if="domainEditManager().isEqual(item) === false 
                   || domainEditManager().getOperation() !== 'name'"
                class="group-name_text">
                {{domainManager(item).getName()}}
          </span>
          <el-form v-else 
                   class="domain-name_form"
                   ref="domainNameForm"
                   size="mini"
                   label-width="0px"
                   label-position="left"
                   onsubmit="return false"
                   :rules="rules"
                   :model="form">
            <el-form-item class="domain-name_form_item"
                          prop="name">
              <el-input size="mini"
                        class="group-name_input"
                        v-model="inputDomainName">
              </el-input>
            </el-form-item>       
          </el-form>
        </div>
        <!-- 组组件操作按钮 -->
        <div class="group-operates">
          <!-- 重命名按钮 -->
          <i v-if="domainEditManager().isEqual(item) == false"
             class="el-icon-erp-edit group-rename-button"
             @click.stop="beforeEditDomainName(item)"></i>
          <!-- 删除按钮 -->
          <i v-if="domainEditManager().isEqual(item) == false"
             class="el-icon-erp-lajitong group-delete-button"
             @click.stop="dialogManage(deleteDomainDialog).show(item)"></i>
          <!-- 编辑保存按钮 -->
          <i v-if="domainEditManager().isEqual(item)"
             class="el-icon-success group-edit-save-button"
             @click.stop="submitSaveDomain"></i>
          <!-- 编辑取消按钮 -->
          <i v-if="domainEditManager().isEqual(item)"
             class="el-icon-error group-edit-cancel-button"
             @click.stop="quitEditDomain"></i>
        </div>
      </li>
    </draggable>

    <!-- 模块修改提示弹窗 -->
    <confirm-dialog v-model="beforeEditConfirmDialog.visible"
                    title="编辑组"
                    icon="el-icon-question"
                    :content="`是否保存${domainEditManager().getDomainName() || '模块'}操作？`">
      <el-button type="primary" 
                 @click="savePreviousEdited">确认</el-button>
      <el-button type="text" style="margin-left: 10px;"
                 @click="directGoEditingDomainStatus">取消</el-button>
    </confirm-dialog>

    <!-- 取消修改提示弹窗 -->
    <el-dialog title="取消编辑"
               width="384px"
               plugin-name="ElLeave"
               :visible.sync="cancelEditDialog.visible">
      <span slot="leave-title">是否确认取消？</span>
      <span slot="leave-auxiliary">取消后,变更内容将不再被保存</span>
      <i slot="leave-icon" class="el-icon-question"></i>
      <template slot="footer">
        <el-button type="cancel" @click="quitEditingAbandonChanged">确认取消</el-button>
        <el-button type="primary" @click="quitEditingSaveChanged">保存数据</el-button>
      </template>
    </el-dialog>
 
    <!-- 模块删除确认弹窗 -->
    <el-dialog v-if="deleteDomainDialog.visible"
               :visible.sync="deleteDomainDialog.visible"
               width="30%"
               title="删除模块"
               plugin-name="ElDelete"
               dialog-content="正在进行删除操作，操作后数据无法恢复，确认继续？"
               description="确认删除模块"
               @confirm-click="confirmDeleteDomain"
               @cancel-click="dialogManage(deleteDomainDialog).hide()">
    </el-dialog>

    <!-- 创建分组 -->
    <grace-dialog
      v-model="dialogManage(newDomainDialog).data"
      :dialog:visible.sync="newDomainDialog.visible"
      dialog:width="570px"
      dialog:title="分组保存"
      dialog:is="domain-save-dialog"
      @submit="submitNewDomain"
      @cancel="dialogManage(newDomainDialog).hide()">
    </grace-dialog>

    <!-- 另存为分组 -->
    <grace-dialog
      v-model="dialogManage(saveAsDialog).data"
      :dialog:visible.sync="saveAsDialog.visible"
      dialog:width="570px"
      dialog:title="分组保存"
      dialog:is="domain-save-dialog"
      @submit="submitSaveAsDomain"
      @cancel="cancelSaveAsDomain">
    </grace-dialog>
  </div>
</template>

<script>
/** 混入方法 ::: 
 *  @mixin mixFormMakeChild 表单编辑组件子级混入
 */
import { mixRiceIndexChild } from "@/mixins/rice_index/mix_rice_index_child.js";
/** 工具方法 ::: 
 *  @function deepCopy 深拷贝方法
 *  @function dialogDefaultConfig 对话框默认配置
 *  @function dialogManage 对话框管理者
 */
import { deepCopy } from "@/utils/utils.js";
import { dialogDefaultConfig, dialogManage } from "@/utils/dialog_manage.js";


export default {
  components: { Draggable: require('vuedraggable') },
  mixins: [ mixRiceIndexChild ],
  data () {
    /** @name 校验模块名称
     *  @author 王汝鹏
     *  @version 2019-12-10
     */
    const validateDomainName = (_, value, callback) => {
      let domainIndex = this.domainList.findIndex(domain => {
        return (value === this.domainManager(domain).getName())
            && (this.domainEditManager().isEqual(domain) === false);
      });
      if (domainIndex !== -1) callback(new Error("已经存在同名模块"));
      else callback();
    }
    return {
      rules: {
        name: [
          { required:true, message:'请输入模块名称', trigger:'change' },
          { validator:validateDomainName, trigger:'change' }
        ]
      },
      // 模块删除确认弹窗
      deleteDomainDialog: dialogDefaultConfig(),
      // 取消编辑模块确认弹窗
      cancelEditDialog: dialogDefaultConfig(),
      // 新建模块命名弹窗
      newDomainDialog: dialogDefaultConfig(),
      // 模块另存为弹窗
      saveAsDialog: dialogDefaultConfig(),
      // 模块组件点击修改提示
      beforeEditConfirmDialog: dialogDefaultConfig(),
    }
  },
  methods: {
    dialogManage,
    /** @name 点击模块名称编辑按钮，进入模块名称编辑状态
     *  @param {Object} domain 模块组件配置
     *  @author 王汝鹏
     *  @version 2020-01-05
     */
    beforeEditDomainName(domain) {
      // 没有模块组件在编辑状态，并且编辑区存在表单项
      // 或者 模块组件已经发生了修改
      //   if T 显示修改模块确认弹窗
      //   else 直接将模块组件表单数据更新到表单编辑区


     if(this.domainEditManager().getStatus() === 'editing') {
       this.$message({type: 'warning', message: '请保存当前正在编辑的分组'})
       return
     }
      if ((this.domainEditManager().getStatus() === 'normal') && (this.formListManager().getLength()>0)
       || (this.domainEditManager().getStatus() === 'changed')) {
        dialogManage(this.beforeEditConfirmDialog).show({ domain, operation:"name" });
      } else {
        this.gotoEditDomainStatus(domain, 'name');
      }
    },
    /** @name 创建一个新的空模块组件
     *  @author 王汝鹏
     *  @version 2019-12-09
     */
    submitNewDomain() {
      // 从保存模块弹窗中取出模块名称
      let domainName = dialogManage(this.newDomainDialog).data;
      // 生成/获取 模块配置数据
      let domainConfig = this.makeDomainConfig(domainName, []);
      // 将新模块配置添加到模块组件列表
      this.domainList.push(domainConfig);
      // 关闭组组件创建对话框
      dialogManage(this.newDomainDialog).hide();
    },
    /** @name 拖动模块组件结束
     *  @param {Object} e 拖动结束事件参数
     *  - {Element} form 拖动前元素容器
     *  - {Element} to 拖动后元素容器
     *  @author 王汝鹏
     *  @version 2019-11-14
     */
    endDraggableDomain(e) {
      let {from, to, oldIndex} = e;

      // 拖动到了表单编辑区
      // 现在模块只能拖拽到表单编辑区, 以后如果有变化需要使用更精确的判断
      if (from !== to) {
        // 取出拖拽的模块组件
        let domain = this.domainList[oldIndex];
        // 表单拖拽区是否有表单项？
        // if T 显示是否保存上次修改弹窗
        // else 将模块数据更新到拖拽区
        (this.formList.length>0)
          ? dialogManage(this.beforeEditConfirmDialog).show({ domain, operation:"templates" })
          : this.gotoEditDomainStatus(domain, 'templates');
      }
    },
    /** @name 点击模块组件,准备进入当前模块编辑状态
     *  @description 
     *    正常状况: 
     *        1. 没有模块在编辑状态，表单编辑区没有表单
     *        2. 有模块在编辑状态，但是没有发生任何修改
     *    提示情况:
     *        1. 没有模块在编辑状态，表单区有表单项，提示是否将表单项另存为模块
     *        2. 有模块在编辑状态，并且已经发生了修改，提示是否保存模块修改
     *  @param {Object} domain 模块配置
     *  @author 王汝鹏
     *  @version 2019-10-06
     */
    beforeEditDomain(domain) {
      // 如果编辑中的就是当前模块组件，不操作
      if (this.domainEditManager().isEqual(domain)) return;

      // 没有模块组件在编辑状态，并且编辑区存在表单项
      // 或者 模块组件已经发生了修改
      //   if T 显示修改模块确认弹窗
      //   else 直接将模块组件表单数据更新到表单编辑区
      if ((this.domainEditManager().getStatus() === 'normal') && (this.formListManager().getLength()>0)
       || (this.domainEditManager().getStatus() === 'changed')) {
        dialogManage(this.beforeEditConfirmDialog).show({ domain, operation:"templates" });
      } else {
        this.gotoEditDomainStatus(domain, 'templates');
      }
    },
    /** @name 进入模块编辑状态
     *  @param {String} domain 模块
     *  @param {String} operation 操作类型 { none:无操作, templates:模版操作, name:名称操作 }
     *  @author 王汝鹏
     *  @version 2019-11-07
     */
    gotoEditDomainStatus(domain, operation) {
      // 初始模块编辑过程数据
      this.domainEditManager().edit(domain, operation);

      // 更新表单编辑区数据，默认激活第一个表单项
      this.formListManager().activeNode(this.formList[0] || {}, this.formList);
    },
    /** @name 保存当前正在编辑的模块
     *  @return {Boolean} 操作结果{true:保存成功，false:操作失败}
     *  @author 王汝鹏
     *  @version 2019-12-10
     */
    async saveEditingDomain() {
      if (this.domainEditManager().getOperation() === 'name') {
        try { await this.$refs['domainNameForm'][0].validate(); }
        catch(err) { console.error("分组名称填写格式不正确;"); return false; }
      }
      if (this.domainEditManager().getOperation() === 'templates') {
        // 更新模块组件表单模版列表
        this.domainEditManager().setTemplates(this.formList);
      }
      // 提交模块组件修改
      this.domainEditManager().submitChanged();
      return true;
    },
    /** @name 保存之前的表单区修改
     *  @description 可能是 “将表单区的修改另存为模块” 或者 “保存之前模块的修改”
     *  @author 王汝鹏
     *  @version 2019-11-07
     */
    async savePreviousEdited() {
      // 判断之前的状态 是否为编辑模块状态？
      // if T 保存之前编辑的模块
      // else 弹出另存为模块命名弹窗
      if (this.domainEditManager().getStatus() !== 'normal') {
        // 保存当前正在编辑的模块 返回操作结果:{true:操作成功，false:操作失败}
        let result = await this.saveEditingDomain();
        if (result === false) return; 

        // 取出模块组件编辑弹窗中记录的模块组件数据
        // 将模块组件表单数据更新到表单编辑区
        let { domain, operation } = dialogManage(this.beforeEditConfirmDialog).data;
        this.gotoEditDomainStatus(domain, operation);

        // 关闭模块编辑确认弹窗
        dialogManage(this.beforeEditConfirmDialog).hide();

      } else { dialogManage(this.saveAsDialog).show(); }
    },
    /** @name 直接进入模块编辑状态,不管以前的表单区状态
     *  @author 王汝鹏
     *  @version 2019-12-09
     */
    directGoEditingDomainStatus() {
      switch (this.domainEditManager().getStatus()) {
        // 清空表单编辑区
        case 'normal': this.formListManager().emptyList(); break;
        // 回退已经修改的东西
        case 'editing':
        case 'changed': this.domainEditManager().rollbackChanged(); break;
      }

      // 关闭模块编辑确认弹窗
      // 取出模块组件编辑弹窗中记录的模块组件数据
      // 将模块组件表单数据更新到表单编辑区
      let { domain, operation } = dialogManage(this.beforeEditConfirmDialog).data;
      dialogManage(this.beforeEditConfirmDialog).hide();
      this.gotoEditDomainStatus(domain, operation);
    },
    /** @name 保存当前编辑中的模块修改
     *  @author 王汝鹏
     *  @version 2019-12-10
     */
    async submitSaveDomain() {
      // 提交当前模块组件的修改 返回操做结果{true:操作成功，false：操作失败}
      let result = await this.saveEditingDomain();
      if (result === false) return; 

      // 清空表单拖拽区
      this.formList = [];
      this.formListManager().activeNode({}, this.formList);
    },
    /** @name 退出编辑状态，保存之前的改动
     *  @author 王汝鹏
     *  @version 2019-12-09
     */
    async quitEditingSaveChanged() {
      // 提交当前模块组件的修改 返回操做结果{true:操作成功，false：操作失败}
      let result = await this.saveEditingDomain();
      if (result === false) return; 

      // 清空表单拖拽区
      this.formList = [];
      this.formListManager().activeNode({}, this.formList);

      // 关弹窗
      dialogManage(this.cancelEditDialog).hide();
    },
    /** @name 退出编辑状态，放弃之前的改动
     *  @author 王汝鹏
     *  @version 2019-12-10
     */
    quitEditingAbandonChanged() {
      // 模块编辑结束
      this.domainEditManager().rollbackChanged();
      // 关弹窗
      dialogManage(this.cancelEditDialog).hide();
      // 清空表单编辑区
      this.formList = [];
      this.formListManager().activeNode(this.formList[0] || {}, this.formList);
    },
    /** @name 确认删除模块组件
     *  @author 王汝鹏
     *  @version 2019-12-10
     */
    confirmDeleteDomain() {
      // 取出删除模块确认弹窗中的数据
      let domain = dialogManage(this.deleteDomainDialog).data;
      // 删除模块组件
      this.domainManager(domain).delete();
      // 关闭弹窗
      dialogManage(this.deleteDomainDialog).hide();
    },
    /** @name 退出模块编辑状态
     *  @author 王汝鹏
     *  @version 2019-12-09
     */
    quitEditDomain() {
      // 模块组件已经发生改动？
      // if T 显示退出编辑确认弹窗
      // else 直接退出编辑状态
      (this.domainEditManager().getStatus() === 'changed')
        ? dialogManage(this.cancelEditDialog).show()
        : this.quitEditingAbandonChanged();
    },
    /** @name 提交另存为模块组件操作
     *  @author 王汝鹏
     *  @version 2019-12-09
     */
    submitSaveAsDomain() {
      // 从保存模块弹窗中取出模块名称
      let domainName = dialogManage(this.saveAsDialog).data;
      // 生成/获取 模块配置数据
      let domainConfig = this.makeDomainConfig(domainName, this.formList);
      // 将新模块配置添加到模块组件列表
      this.domainList.push(domainConfig);
      // 取出模块组件编辑弹窗中记录的模块组件数据
      // 将模块组件表单数据更新到表单编辑区
      let { domain, operation } = dialogManage(this.beforeEditConfirmDialog).data;
      this.gotoEditDomainStatus(domain, operation);

      // 关闭组组件创建对话框
      dialogManage(this.saveAsDialog).hide();
      dialogManage(this.beforeEditConfirmDialog).hide();
    },
    /** @name 取消将表单另存为模块组件
     *  @author 王汝鹏
     *  @version 2019-12-09
     */
    cancelSaveAsDomain() {
      // 关闭组组件创建对话框
      dialogManage(this.saveAsDialog).hide();
      dialogManage(this.beforeEditConfirmDialog).hide();
    }
  },
  computed: {
    form() {
      return { name:this.inputDomainName };
    },
    inputDomainName: {
      get() { return this.domainEditManager().getDomainName(); },
      set(name) { this.domainEditManager().setDomainName(name); }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Config/GroupItemConfig.vue